import './ContactPageElementsCss/ContactInfoSection.css';
import AnimatedText from '../../AnimatedText';
import { FaPhoneAlt, FaMapMarkerAlt, FaEnvelope } from 'react-icons/fa';

export default function ContactInfoSection() {
    return (
        <>
            
            <div className="ourPackageContainer contactUsContainer">
                <div className="ourPackageUpperSection">
                    <AnimatedText tag="h2" type="words" y={30} className="rb-title ourpackageTitle">
                        Connect With Our Branches
                    </AnimatedText>

                    <div className="contactAddressBody">
                        <div className="contactBodyLeftSection">
                            <div className="contact-card">
                                <h3 className="contact-title"><strong>Head Office: </strong>Laketown, Kolkata</h3>
                                <hr className="contact-divider" />

                                <div className="contact-item">
                                    <FaPhoneAlt className="contact-icon" />
                                    <span>033 4085 4085</span>
                                </div>

                                <div className="contact-item">
                                    <FaMapMarkerAlt className="contact-icon" />
                                    <span>
                                        Laketown Address - P-846, Block A, Lake Town Kolkata - 700089
                                    </span>
                                </div>

                                <div className="contact-item">
                                    <FaEnvelope className="contact-icon" />
                                    <span>info@rbdiagnostics.com</span>
                                </div>
                            </div>
                        </div>
                        <div className="contactBodyRightSectioin">
                            <iframe
                                title="RB Diagnostic LakeTown Map"
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3683.6218742870313!2d88.39939391504797!3d22.609214485165763!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a0275fddb4edc83%3A0xc767c47fc34c4ade!2sRB%20Diagnostic%20LakeTown!5e0!3m2!1sen!2sin!4v1718999812345!5m2!1sen!2sin"
                                width="100%"
                                height="400"
                                style={{ border: 0 }}
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                            />
                        </div>

                    </div>

                </div>
            </div>
        </>
    )
}